import moment from "moment"
import { forwardRef, useEffect, useState } from "react"
import { Card, Col, Dropdown, FormControl, InputGroup, Jumbotron, Row } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { withTranslation } from "react-i18next"
import Get from "../../api/Get"
import { REPORT_APPOINTMENTONDEMAND } from "../../api/Routes"
import TableSearch from "../TableSearch"
import { FaCalendar } from "react-icons/fa"
import ComponentModalErrorSever from "../ComponentModalErrorSever"

function KpiCitasOnDemand({t, auth}){
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [date, setDate] = useState(new Date())
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        if(date){
            setLoading(true)
            Get({url: `${REPORT_APPOINTMENTONDEMAND}/${moment(date).format("DD-MM-YYYY")}`, access_token: auth.data.access_token})
            .then(response=>{
                setItems(response.data.data.response)
                setLoading(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setItems([])
                setLoading(false)
            })
        }else{
            setItems([])
        }
        
    }, [date])

    const formatStatus = (cell) => {
        return (
            cell === "ASIGNADA" ? 
            <span className="badge badge-success">Asignado</span> :
            <span className="badge badge-danger">No asignado</span>
        )
    }


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        },
        {
            text: 'No. consecutivo',
            isDummyField: true,
            dataField: '',
            formatter: (cell, row, index) => index+1,
            headerStyle: {  width: '10%'},
            style:{ textAlign: 'center'},
        },
        {
            text: 'Cuenta',
            dataField: 'accountName',
            headerStyle: {  width: '30%'}
        },
        {
            text: 'Especialidad',
            dataField: 'specialty',
            headerStyle: {  width: '30%'}
        },
        {
            text: 'Fecha solicitud',
            dataField: 'requestDateTime',
            /* formatter: formatDate, */
            headerStyle: {  width: '20%'}
        },
        {
            text: 'Resultado',
            dataField: 'status',
            formatter: formatStatus,
            headerStyle: {  width: '10%', textAlign:'center'},
            style:{ textAlign: 'center'},
        },
        {
            text: 'Motivo',
            dataField: 'reasonStatus',
            headerStyle: {  width: '20%'}
        },
        {
            text: 'Doctor asignado',
            dataField: 'doctorName',
            headerStyle: {  width: '20%'}
        }
    ]

    const CustomInputDate = forwardRef(({ value, onClick }, ref) => (
        <InputGroup className="mb-3 input-group-sm">
            <FormControl
                placeholder="Recipient's username"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                ref={ref}
                defaultValue={value}
            />
            <InputGroup.Text id="basic-addon2" onClick={onClick} className="rounded-0 cursor-pointer"><FaCalendar /></InputGroup.Text>
        </InputGroup>
      ));

    return(
        <Card className="shadow-1">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <div className="mr-5"><h6>Solicitud de Consultas OnDemand</h6></div>                                
                    <div>
                        <DatePicker
                            className="form-control"
                            selected={date} 
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            onChange={date => setDate(date)}
                            locale={ 'es'}
                            customInput={<CustomInputDate />}
                        />                        
                    </div>
                </div>
                <Dropdown.Divider />
                <Row>
                    {
                        (items.length === 0 && !loading) &&
                        <Col xs="12" md="12">
                            <Jumbotron>
                                <div className="text-center">
                                    <p className="m-0">No existe información a mostrar</p>
                                </div>
                            </Jumbotron>
                        </Col>                                    
                    }
                    {
                        loading && 
                        <Col xs="12" md="12">
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </Col>
                    }
                    {
                        (items.length > 0 && !loading) &&     
                        <Col xs="12" md="12">
                            <TableSearch columns={columns} items={items} className="th-text-uppercase" placeholderSearch=" por cuenta,especialidad,fecha de solicitud,motivo y doctor asignado" />
                        </Col>
                    }                       
                </Row>
            </Card.Body>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </Card>
    )

}

export default withTranslation()(KpiCitasOnDemand)